import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { redeemReward } from "./api";

const useUploadImageProof = ({
  spinWheelRewardsState,
  setSpinWheelRewardsState,
  refetch,
}) => {
  const validation = Yup.object({
    image: Yup.mixed()
      .test(
        "fileType",
        "Please upload an image in JPEG or PNG format",
        (value) => {
          if (value) {
            const supportedFormats = ["image/jpeg", "image/png"];
            return supportedFormats.includes(value.type);
          }
          return true;
        }
      )
      .test("fileSize", "File size must be less than 5 MB", (value) => {
        if (value) {
          const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
          return value.size <= maxSize;
        }
        return true;
      }),
  });
  const formik = useFormik({
    initialValues: {
      image: "",
    },
    validationSchema: validation,
    onSubmit: (values, { setSubmitting }) => {
      let data = {
        image: values?.image ?? "",
        reward_id: spinWheelRewardsState?.itemId ?? "",
      };
      // if (values?.image instanceof File) {
      //   data.image = values.image;
      // }
      let formData = new FormData();
      for (let key in data) {
        if (data[key] !== undefined && data[key] !== null && data[key] !== "") {
          formData.append(key, data[key]);
        }
      }
      redeemReward(formData).then((response) => {
        if (response?.data?.status_code === 200) {
          toast.success(`Updated successfully`);
          refetch();
          handleCloseModal();
          setSubmitting(false);
        } else if (response?.status_code === 422 && response?.errors) {
          Object.keys(response?.errors).forEach((field) => {
            formik.setFieldError(field, response?.errors[field]);
          });
          setSubmitting(false);
        } else {
          toast.error(`Something went wrong!`);
          handleCloseModal();
          setSubmitting(false);
        }
      });
    },
  });
  const handleCloseModal = () => {
    setSpinWheelRewardsState((prev) => ({
      ...prev,
      uploadImageModal: false,
    }));
  };
  return {
    formik,
    handleCloseModal,
  };
};

export default useUploadImageProof;
